module.exports = "https://static.wmbcdn.com/uniweb/images/1c30af8069e1041587b675cfe1194984.svg";